module.exports = __webpack_public_path__ + "img/img14.01653675.svg";